import { Segment, Form, Button, Checkbox } from 'semantic-ui-react';
import {
  isAssociateManagerOrAbove,
  canSubmitStanddownInspection,
  isReadOnly,
} from '../auth';

export const ActionButtons = ({
  isEdit,
  assetInspection,
  formErrors,
  handleFieldChange,
  handleApprove,
  handleDeny,
  handleSubmit,
  handleSaveDraft,
  fieldValues
}) => (
  <>
    {isAssociateManagerOrAbove() && 
     !assetInspection?.isInspectedByAM && 
     fieldValues.length > 0 && 
     isEdit && (
      <Segment>
        <Form.Field>
          <label>Re-inspection Required?</label>
          <Checkbox
            toggle
            checked={assetInspection.reInspection}
            value={assetInspection.reInspection}
            onChange={(e, value) => handleFieldChange('reInspection', value.checked)}
          />
        </Form.Field>
        <Form.TextArea
          label="Reason"
          placeholder="Enter reason for denial"
          value={assetInspection?.reason}
          onChange={(e) => handleFieldChange('reason', e.target.value)}
          error={formErrors ? formErrors.reason : null}
        />
        {!assetInspection?.isInspectedByAM && 
         assetInspection?.status === "pending" && (
          <>
            <Button 
              type="button"
              style={{ backgroundColor: "var(--add)", color: "white" }}
              onClick={handleApprove}
            >
              Approve
            </Button>
            <Button 
              type="button"
              style={{ backgroundColor: "var(--delete)", color: "white" }}
              onClick={handleDeny}
            >
              Deny
            </Button>
          </>
        )}
      </Segment>
    )} 

    {!isReadOnly() && (canSubmitStanddownInspection() || assetInspection?.isInspectedByAM) &&
      ((assetInspection?.status === "pending" || assetInspection?.status === "denied" || assetInspection?.status === "draft" || !isEdit)) &&
      fieldValues.length > 0 && (
      <Segment>
        <Form.TextArea
          label="Comments"
          placeholder="Enter comments (optional)"
          value={assetInspection?.comments}
          onChange={(e) => handleFieldChange('comments', e.target.value)}
        />
        <Button primary onClick={() => handleSubmit()}>
          {isEdit ? 'Update' : 'Submit'}
        </Button>
        {(!isEdit || assetInspection?.status === 'draft') && (
          <Button type="button" color="grey" style={{ marginBottom: 16 }} onClick={handleSaveDraft}>
            Save as Draft
          </Button>
        )}
      </Segment>
    )}
  </>
);